/* Independent custom elements allow Shopify to add/reload sections without global listeners. */
(() => {
  if (!customElements.get('br-gallery')) {
    customElements.define('br-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-show]');
          if (button && this.contains(button)) this.show(Number(button.dataset.show));
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('[data-slide]');
          if (slide) this.show(Number(slide.dataset.slide));
        }, options);
      }
      show(index) {
        const slides = [...this.querySelectorAll('[data-slide]')];
        if (!slides.some(slide => Number(slide.dataset.slide) === index)) return;
        slides.forEach(slide => {
          const active = Number(slide.dataset.slide) === index;
          slide.hidden = !active;
          if (!active) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        this.querySelectorAll('[data-show]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.show) === index)));
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  if (!customElements.get('br-product')) {
    customElements.define('br-product', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('change', event => { if (event.target.matches('[data-variant-select]')) this.updateVariant(); }, options);
        this.addEventListener('click', event => {
          const swatch = event.target.closest('[data-variant]');
          const select = this.querySelector('[data-variant-select]');
          if (swatch && select) { select.value = swatch.dataset.variant; this.updateVariant(); }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const details = event.target.querySelector('details.br-accordion');
          if (details) details.open = true;
        }, options);
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) this.querySelectorAll('video[autoplay]').forEach(video => { video.autoplay = false; video.pause(); });
        this.updateVariant();
      }
      updateVariant() {
        const option = this.querySelector('[data-variant-select]')?.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        this.querySelectorAll('[data-price]:not(option)').forEach(el => { el.textContent = option.dataset.price || ''; });
        this.querySelectorAll('[data-compare]:not(option)').forEach(el => { el.textContent = option.dataset.compare || ''; });
        this.querySelectorAll('[data-buy]').forEach(button => {
          button.disabled = !available;
          button.querySelector('[data-buy-label]').textContent = available ? button.dataset.add : button.dataset.sold;
          const price = button.querySelector('[data-buy-price]');
          if (price) price.hidden = !available;
        });
        this.querySelectorAll('[data-variant]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.variant === option.value)); });
        const slide = [...this.querySelectorAll('[data-slide]')].find(el => el.dataset.mediaId && el.dataset.mediaId === option.dataset.mediaId);
        if (slide) this.querySelector('br-gallery')?.show(Number(slide.dataset.slide));
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  if (!customElements.get('br-reviews')) {
    customElements.define('br-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = [...this.querySelectorAll('[data-review]')];
        this.button = this.querySelector('[data-more]');
        if (!this.button) return;
        this.count = window.Shopify?.designMode ? this.cards.length : Number(this.button.dataset.initial);
        this.grid = this.querySelector('.br-review-grid');
        if (window.ResizeObserver && this.grid) {
          this.grid.classList.add('br-masonry');
          this.observer = new ResizeObserver(() => this.layout());
          this.observer.observe(this.grid);
          this.cards.forEach(card => this.observer.observe(card));
        }
        this.update();
        this.button.addEventListener('click', () => { this.count += Number(this.button.dataset.step); this.update(); }, options);
        this.addEventListener('shopify:block:select', () => { this.count = this.cards.length; this.update(); }, options);
      }
      update() { this.cards.forEach((card, index) => { card.hidden = index >= this.count; }); this.button.hidden = this.count >= this.cards.length; this.layout(); }
      layout() {
        if (!this.observer) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const gap = parseFloat(getComputedStyle(this.grid).rowGap) || 10;
          this.cards.forEach(card => {
            if (!card.hidden) card.style.gridRowEnd = `span ${Math.ceil((card.getBoundingClientRect().height + gap) / (8 + gap))}`;
          });
        });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
    });
  }
})();
